<template>
    <div id="app">
      <header>
        <h1>养殖塘信息</h1>
      </header>
      <main>
        <div class="info-container">
          <div class="info-item">
            <label>公司名称:</label>
            <span>{{ data.comName }}</span>
          </div>
          <div class="info-item">
            <label>地址:</label>
            <span>{{ data.address }}</span>
          </div>
          <div class="info-item">
            <label>塘名:</label>
            <span>{{ data.pondName }}</span>
          </div>
          
          <div class="info-item">
            <label>养殖鱼类:</label>
            <span>{{ data.fishName }}</span>
          </div>
          <div class="info-item">
            <label>面积 (m²):</label>
            <span>{{ data.fishArea }}</span>
          </div>
        </div>
      </main>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        data: {
          comName: "",
          address: "",
          pondName: "",
          fishName: "",
          fishArea: "",
        },
      };
    },
    mounted() {
    // 获取 URL 参数中的 comid
    const comid = this.$route.query.comid;
    const pondid = this.$route.query.pondid;
    this.fetchPondData(comid);
    // if (comid,pondid) {
    //   this.fetchPondData(comid);
    // } else {
    //   console.error("comid 参数缺失");
    // }
  },
  methods: {
        async fetchPondData(comid) {
        try {
            // 将 comid 作为参数传递给 API
            this.request.get('/api/or/getMessage', {
            params: {
                comid: comid,
                // pondid: pondid
            },
            }).then(res => {
            if (res.code === "200") {
                // 将返回的数据赋值给 data
                this.data = res.data;
            } else {
                console.log(res.msg);
            }
            }).catch(error => {
            console.error(error);
            })
        }catch (error) {
            console.error("Error fetching data:", error);
        }
    },
  }
}
  </script>
  
  <style scoped>
  #app {
    font-family: Arial, sans-serif;
    color: #333;
    padding: 20px;
    max-width: 600px;
    margin: 0 auto;
    background: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  header {
    text-align: center;
    margin-bottom: 20px;
  }
  
  h1 {
    font-size: 24px;
    margin: 0;
  }
  
  .info-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .info-item {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  label {
    font-weight: bold;
  }
  
  span {
    color: #555;
  }
  </style>
  